import OtherRatesRow from './OtherRatesRow';

export default OtherRatesRow;
